import React from 'react';
import styled from 'styled-components';

import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';
import FaCheckCircle from 'react-icons/lib/fa/check-circle';
import { media } from '../../utilities/style-utilities';
import { fontUbuntuLight } from '../../utilities/utilities';

const SizedExclamationTriangle = styled(FaExclamationTriangle)`
  font-size: 1.5rem;
  color: #ffffff;
`;

const SizedCheckCircle = styled(FaCheckCircle)`
  font-size: 1.5rem;
  color: #ffffff;
`;

const StatusBox = styled.div`
  display: ${props => props.isVisible === true ? 'flex' : 'none' };
  background-color: ${props => (props.type === 'error') ?`#f0dddd`:`#eef3e5`}
  color: ${props => (props.type === 'error') ?`#a84343`:`#80A843`}
 // color: #a84343;
 // border: 1px solid #d12f2c;
  border: 1px solid ${props =>(props.type === 'error') ?`#a84343`:`#80a843`};
  align-self: center;
  padding: 0.5rem;
  width: 600px;
  
  ${ media.tablet`
    width: 100%;
  `}
`;

const StatusMessage = styled.span`
  display: inline-flex;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-size: 0.8875em;
  flex: 1 1 auto;
  align-self: center;
  justify-content: center;
`;

const Icon = styled.span`
  border: 2px solid #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  padding: 0.4rem;  
  margin-right: 0.5rem;
  align-items: center;
  background-color:${props => (props.type === 'error') ?`#a84343`:`#80a843`}
  align-self: baseline;
  flex:0 0 auto;
`;
const StatusIcon = (props) => {
    return (props.type === 'error')?  <SizedExclamationTriangle/> : <SizedCheckCircle/>;
};

const Status= (props) => {
  return (
    <StatusBox isVisible={props.isVisible} type={props.type}>
        <Icon type={props.type}>
          <StatusIcon type={props.type} />
        </Icon>
        <StatusMessage>{props.message}</StatusMessage>
    </StatusBox>
  )
};

export default Status;


// WEBPACK FOOTER //
// ./src/components/Status/Status.js